var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 8.5H9.66658V9.83333H10.9999M10.9999 5.83333H9.66658V7.16667H10.9999M12.3333 11.1667H6.99992V9.83333H8.33325V8.5H6.99992V7.16667H8.33325V5.83333H6.99992V4.5H12.3333M5.66658 3.16667H4.33325V1.83333H5.66658M5.66658 5.83333H4.33325V4.5H5.66658M5.66658 8.5H4.33325V7.16667H5.66658M5.66658 11.1667H4.33325V9.83333H5.66658M2.99992 3.16667H1.66659V1.83333H2.99992M2.99992 5.83333H1.66659V4.5H2.99992M2.99992 8.5H1.66659V7.16667H2.99992M2.99992 11.1667H1.66659V9.83333H2.99992M6.99992 3.16667V0.5H0.333252V12.5H13.6666V3.16667H6.99992Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallBuilding);
export default __webpack_public_path__ + "static/media/small_building.5a1836b705f278c3ba259ebbc90e7170.svg";
export { ForwardRef as ReactComponent };